<template>
  <div>
    <loader :loader="sending" />
    <v-data-table
      :headers="headers"
      :items="list"
      :items-per-page="itemsPerPage"
      sort-by="startTime"
      :sort-desc="true"
      no-data-text="Sin resultados disponibles"
      dense
      fixed-header
      hide-default-footer
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip
          left
          v-if="$utilFront.withPermission($prm.MODULE_TELEMEDICINE_VIEW)"
          color="primary"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="isViewDetailsTable(item.idMedicalPractice)">
              <v-icon color="blue" v-bind="attrs" v-on="on">
                mdi-information-variant
              </v-icon>
            </v-btn>
          </template>
          <span>Ver información</span>
        </v-tooltip>

        <v-menu offset-y :nudge-width="200" :close-on-content-click="true">
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip left color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <span>Más opciones</span>
            </v-tooltip>
          </template>
          <v-list dense>
            <v-list-item
              link
              @click="isEditableTable(item.idMedicalPractice)"
              v-if="$utilFront.withPermission($prm.MODULE_TELEMEDICINE_EDIT)"
            >
              <v-list-item-icon>
                <v-icon color="warning" small> mdi-pencil </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Editar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              @click="generatePDF(item)"
              v-if="
                $utilFront.withPermission($prm.MODULE_TELEMEDICINE_DOWNLOAD_PDF)
              "
            >
              <v-list-item-icon>
                <v-icon color="error" small> mdi-file-pdf-box </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Telemedicina</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:[`item.startTime`]="{ item }">
        {{ $utilFront.formatDateTime(item.startTime) }}
      </template>
    </v-data-table>
    <v-card-actions align="center">
      <v-col
        v-if="$utilFront.withPermission($prm.MODULE_COLPOSCOPY_EXPORT_EXCEL)"
      >
        <v-btn
          outlined
          small
          color="green darken-1"
          :disabled="sending"
          @click="downloadReportXLSX()"
        >
          Exportar atenciones
          <v-icon right>mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-col>
    </v-card-actions>
  </div>
</template>

<script>
import MenuCrud from "@/app/components/base/menu/MenuCrud.vue";
import CancelationModal from "@/app/components/common/CancelationModal.vue";
import TelemedicineHistoryService from "@/app/services/TelemedicineHistoryService"
import Loader from "@/app/components/base/loader/Loader.vue";
import CalculatorsSomatometryRequest from "@/core/request/CalculatorsSomatometryRequest"


export default {
  name: "TelemedicineHistoryTable",
  props: {
    list: Array,
    get: Function,
    getColposcopy: Function,
    deleteItem: Function,
    updateStatus: Function,
    itemsPerPage: Number,
  },
  components: {
    MenuCrud,
    CancelationModal,
    Loader,
  },
  data() {
    return {
      sending: false,
      idPatient: null,
      appointmentDialog: false,
      dataModal: {},
      dialogCancelation: false,
      dialogConfirmStart: false,
      selectedItem: null, 
      calculatorsData: [],
      headers: [
        {
          text: "Id Consulta",
          value: "idMedicalPractice",
          sortable: false,
          align: "center",
          width: "20%",
        },
        {
          text: "Id Paciente",
          value: "idPatient",
          sortable: false,
          align: "center",
          width: "10%",
        },
        {
          text: "Nombre del paciente",
          value: "fullName",
          align: "center",
          sortable: false,
        },
        {
          text: "Nombre del Doctor",
          value: "fullNameDoctor",
          align: "center",
          sortable: false,
        },
        {
          text: "Fecha y hora de atención",
          value: "startTime",
          align: "center",
          sortable: false,
          width: "20%",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          width: "15%",
        },
      ],
    };
  },
  methods: {
    generatePDF({ idMedicalPractice, time, idPatient }) {
    this.sending = true;
    if (idMedicalPractice) {
      const data = {
        idMedicalPractice,
        fileName: `Consulta_Telemedicina_${idMedicalPractice}_${time}`,
        idBranchOffice: this.$utilFront.getIdBranchOffice(),
        idPatient,
        type: 1  
      };
      TelemedicineHistoryService.pdf(data)
        .then((res) => {
          if (res.status === 200 && res.data.type !== "application/json") {
            this.$utilFront.openPDF(res.data);
          } else {
            this.$utilFront.displayErrorPdf(res.data);
          }
        })
        .finally(() => {
          this.sending = false;
        });
    }
  },
    
  isViewDetailsTable(idMedicalPractice) {
  const item = this.list.find(i => i.idMedicalPractice === idMedicalPractice);
  if (!item) {
    console.warn("No se encontró el item con idMedicalPractice =", idMedicalPractice);
    return;
  }
  
  const payload = {
    evaluationTypes: [9, 10, 11],
    idPerson: item.idPerson,                
    idClinicalEvent: item.idClinicalEvent || null,
  };

  CalculatorsSomatometryRequest.getCalculatorsSomatometry(payload)
    .then((res) => {
      localStorage.setItem("calculatorsData", JSON.stringify(res.data));
      
      let isViewDetails = true;
      this.$emit("isViewDetails", isViewDetails);
      this.get(idMedicalPractice, 3, null, true);
    })
    .catch((error) => {
      console.error("Error al obtener calculadoras: ", error);
    });
},

isEditableTable(idMedicalPractice) {
  const item = this.list.find(i => i.idMedicalPractice === idMedicalPractice);
  if (!item) {
    console.warn("No se encontró el item con idMedicalPractice =", idMedicalPractice);
    return;
  }

  const payload = {
    evaluationTypes: [9, 10, 11],
    idPerson: item.idPerson,
    idClinicalEvent: item.idClinicalEvent || null,
  };

  CalculatorsSomatometryRequest.getCalculatorsSomatometry(payload)
    .then((res) => {
      localStorage.setItem("calculatorsData", JSON.stringify(res.data));
      
      let isViewDetails = false;
      this.$emit("isViewDetails", isViewDetails);
      this.get(idMedicalPractice, 3, null, true);
    })
    .catch((error) => {
      console.error("Error al obtener calculadoras: ", error);
    });
},

    downloadReportXLSX() {
      if (!this.sending) {
        this.sending = true;

        let data = {
          search: this.search,
          idBranchOffice: this.$utilFront.nonEmpty(
            this.idBranchOffice,
            this.$utilFront.getIdBranchOffice()
          ),
        };

        let rangeName = "";

        if (this.$utilFront.nonEmpty(this.range)) {
          data.start = this.$utilFront.startOfDay(this.range.start);
          data.end = this.$utilFront.endOfDay(this.range.end);
          rangeName = ` del ${this.$utilFront.formatDate(
            data.start
          )} al ${this.$utilFront.formatDate(data.end)}`;
        }

        let fileName = `Historial de atenciones - Telemedicina${rangeName}.xlsx`;

        TelemedicineHistoryService.excel(data)
          .then((res) => {
            let { data } = res;
            this.$utilFront.downloadXLSX(data, fileName);
          })
          .catch((error) => {
            this.$utilFront.errorhttp(error);
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },

  },
};
</script>
